import React from 'react'

import WebView from 'react-native-webview'

interface Props {
  uri: string
  onLoad: () => void
}

const PDFViewer = (props: Props) => {
  const { uri, onLoad } = props
  // TODO: Add chrometabs
  return (
    <WebView
      source={{ uri }}
      onLoad={onLoad}
      androidHardwareAccelerationDisabled
    />
  )
}

export default PDFViewer
